import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CyclopsHttp } from './app.http';

@Injectable({
  providedIn: 'root',
})
export class AumyeDashboardService {
  constructor(private cyclopsHttp: CyclopsHttp) {}
  onGetDashboardData(): Observable<any> {
    return this.cyclopsHttp.get('GetDashboardData');
  }
  onGetRangedIncidentTabData(params: any): Observable<any> {
    return this.cyclopsHttp.post('GetRangedIncidentData', params);
  }
  onGetRangedVisitorTabData(params: any): Observable<any> {
    return this.cyclopsHttp.post('GetRangedVisitorData', params);
  }
  onGetRangedServiceTabData(params: any): Observable<any> {
    return this.cyclopsHttp.post('GetRangedUserComplaints', params);
  }
  onCheckVisitorExists(params: any): Observable<any> {
    return this.cyclopsHttp.post('CheckExistingVisitor', params);
  }
  onGetVisitorTabData(): Observable<any> {
    return this.cyclopsHttp.get('GetVisitorData');
  }
  onGetVisitorById(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetVisitorById', id);
  }
  onGetIncidentById(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetIncidentById', id);
  }
  onGetUserById(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetUserById', id);
  }
  onGetRequestById(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetUserRequestById', id);
  }
  onGetClaimById(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetUserClaimById', id);
  }
  onGetComplaintById(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetUserComplaintById', id);
  }
  onGetEmployeeAttendanceById(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetEmployeeAttendanceById', id);
  }
  onGetIncidentTabData(): Observable<any> {
    return this.cyclopsHttp.get('GetIncidentData');
  }
  onVisitorNotifyHost(params: any): Observable<any> {
    return this.cyclopsHttp.post('NotifyHost', params);
  }
  onCheckHostStatus(params: any): Observable<any> {
    return this.cyclopsHttp.post('GetHostStatus', params);
  }
  onClearVisitorEntry(params: any): Observable<any> {
    return this.cyclopsHttp.post('ClearVisitorEntry', params);
  }
  onGetOrgUserList(): Observable<any> {
    return this.cyclopsHttp.get('GetOrgUserList');
  }
  onGetOrgAssetsList(): Observable<any> {
    return this.cyclopsHttp.get('Assets');
  }
  onCreateManualEvent(params: any): Observable<any> {
    return this.cyclopsHttp.post('CreateManualEvent', params);
  }
  onVerifyIncident(params: any): Observable<any> {
    return this.cyclopsHttp.post('VerifyIncident', params);
  }
  onSnoozeIncident(params: any): Observable<any> {
    return this.cyclopsHttp.post('SnoozeIncident', params);
  }
  onGetOrgNumberPlateList(): Observable<any> {
    return this.cyclopsHttp.get('GetNumberPlateList');
  }
  onGetFaceTime(): Observable<any> {
    return this.cyclopsHttp.get('GetFaceTimeline');
  }
  onGetEvidence(params: any): Observable<any> {
    return this.cyclopsHttp.post('GetIncidentEvidence', params);
  }
  onLodgeUserComplains(params: any): Observable<any> {
    return this.cyclopsHttp.post('RegisterComplain', params);
  }
  onBulkUpload(params: any): Observable<any> {
    return this.cyclopsHttp.post('ConvertCsvToJson', params);
  }
  onBulkSendInvitation(params: any): Observable<any> {
    return this.cyclopsHttp.post('SendBulkInvitation', params);
  }
  onCreateNoticeBoardPost(params: any): Observable<any> {
    return this.cyclopsHttp.post('CreatePost', params);
  }
  onGetNoticeBoardPosts(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetPosts');
  }
  onGetUserEventsList(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetUserEventsList', params);
  }
  onPostUserComment(params: any): Observable<any> {
    return this.cyclopsHttp.post('PostComment', params);
  }
  onPostUserLike(params: any): Observable<any> {
    return this.cyclopsHttp.post('PostLike', params);
  }
  onReportCommunityPost(params: any): Observable<any> {
    return this.cyclopsHttp.post('ReportCommunityPost', params);
  }
  onRemoveUserPermanently(params: any): Observable<any> {
    return this.cyclopsHttp.post('RemoveUserPermanently', params);
  }
  onAcceptOrRejectPost(params: any): Observable<any> {
    return this.cyclopsHttp.post('ApproveRejectPost', params);
  }
  onUpdateFlaggedPost(params: any): Observable<any> {
    return this.cyclopsHttp.post('UpdateFlagPost', params);
  }
  onPreApprovedVisitor(params: any): Observable<any> {
    return this.cyclopsHttp.post('PreApprovedVisitor', params);
  }
  onRapidScheduleVisitor(params: any): Observable<any> {
    return this.cyclopsHttp.post('RapidVisitor', params);
  }
  onCreateUserPoll(params: any): Observable<any> {
    return this.cyclopsHttp.post('CreateUserPoll', params);
  }
  onGetUserPolls(): Observable<any> {
    return this.cyclopsHttp.get('GetUserPolls');
  }
  onManageOrgPolls(): Observable<any> {
    return this.cyclopsHttp.post('ManageUserPolls');
  }
  onSubmitPollResponse(params: any): Observable<any> {
    return this.cyclopsHttp.post('SubmitUserPollResponse', params);
  }
  onUpdateVisitorDetails(params: any): Observable<any> {
    return this.cyclopsHttp.post('UpdateVisitor', params);
  }
  getVisitorData(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetVisitorSecurityPass', id);
  }
  getNewIncidentData(id: string): Observable<any> {
    return this.cyclopsHttp.get('GetIncidentById', id);
  }
  onSendReportsData(params: any): Observable<any> {
    return this.cyclopsHttp.post('SendReportsData', params);
  }
  onGetEmployees(): Observable<any> {
    return this.cyclopsHttp.get('GetEmployees');
  }
  onUpdateEmployees(params: any): Observable<any> {
    return this.cyclopsHttp.post('UpdateEmployees', params);
  }
  onLogEmployeeAttendance(params: any): Observable<any> {
    return this.cyclopsHttp.post('AddEmployeeAttendance', params);
  }
  onSendEmployeeQR(params: any): Observable<any> {
    return this.cyclopsHttp.post('SendEmployeeQR', params);
  }
  onSearchNumber(params: any): Observable<any> {
    return this.cyclopsHttp.post('SearchNumber', params);
  }
  onSetOrganizationSetting(params: any): Observable<any> {
    return this.cyclopsHttp.post('SetOrganizationSetting', params);
  }
  onGetOrgSettings(): Observable<any> {
    return this.cyclopsHttp.get('OrganizationSettings');
  }
  onManageVisitor(params: any): Observable<any> {
    return this.cyclopsHttp.post('UpdateVisitor', params);
  }
  onSaveUserInventory(params: any): Observable<any> {
    return this.cyclopsHttp.post('SaveUserInventory', params);
  }
  onGetUserInventory(): Observable<any> {
    return this.cyclopsHttp.get('GetUserInventory');
  }
  onRequest(params?: any): Observable<any> {
    return this.cyclopsHttp.post('RequestSoS', params);
  }
  onGetComplaintsTickets(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetUserComplaints', params);
  }
  onGetClaimTickets(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetUserClaims', params);
  }
  onGetRequestTickets(params?: any): Observable<any> {
    return this.cyclopsHttp.get('GetUserRequests', params);
  }
  onClusterPreApproved(params: any): Observable<any> {
    return this.cyclopsHttp.post('ClusterPreApproved', params);
  }
  onSaveAppToken(params: any): Observable<any> {
    return this.cyclopsHttp.post('SaveAppToken', params);
  }
  onRemoveAppToken(params: any): Observable<any> {
    return this.cyclopsHttp.post('RemoveAppToken', params);
  }
  onAddUsersToEmployees(params: any): Observable<any> {
    return this.cyclopsHttp.post('AddUsersToEmployees', params);
  }
  getClientAccessUri(): Observable<any> {
    return this.cyclopsHttp.get('GetClientAccessUri');
  }
}
